/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FileFormatTxtIcon16Light } from './FileFormatTxtIcon16Light';
import { FileFormatTxtIcon16Regular } from './FileFormatTxtIcon16Regular';
import { FileFormatTxtIcon16Solid } from './FileFormatTxtIcon16Solid';
import { FileFormatTxtIcon20Light } from './FileFormatTxtIcon20Light';
import { FileFormatTxtIcon20Regular } from './FileFormatTxtIcon20Regular';
import { FileFormatTxtIcon20Solid } from './FileFormatTxtIcon20Solid';
import { FileFormatTxtIcon24Regular } from './FileFormatTxtIcon24Regular';
import { FileFormatTxtIcon24Solid } from './FileFormatTxtIcon24Solid';
import { FileFormatTxtIcon32Regular } from './FileFormatTxtIcon32Regular';
import { FileFormatTxtIcon64Regular } from './FileFormatTxtIcon64Regular';
var sizes = {
    16: {
        light: FileFormatTxtIcon16Light,
        regular: FileFormatTxtIcon16Regular,
        solid: FileFormatTxtIcon16Solid,
    },
    20: {
        light: FileFormatTxtIcon20Light,
        regular: FileFormatTxtIcon20Regular,
        solid: FileFormatTxtIcon20Solid,
    },
    24: {
        regular: FileFormatTxtIcon24Regular,
        solid: FileFormatTxtIcon24Solid,
    },
    32: {
        regular: FileFormatTxtIcon32Regular,
    },
    64: {
        regular: FileFormatTxtIcon64Regular,
    },
};
export var FileFormatTxtIcon = forwardRef('FileFormatTxtIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
